

//start for cart cupons
function initAccordion(scope = document) {
  scope.querySelectorAll(".accordion-button").forEach((btn) => {
    if (btn.dataset.bound === "true") return;
    btn.dataset.bound = "true";

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const item = btn.closest(".accordion-item");
      const content = btn.nextElementSibling;
      if (!item || !content || !content.classList.contains("accordion-content")) return;

      const isActive = item.classList.contains("active");

      scope.querySelectorAll(".accordion-item.active").forEach((el) => {
        el.classList.remove("active");
      });

      if (!isActive) {
        item.classList.add("active");
      }
    });
  });
}

// initial load
document.addEventListener("DOMContentLoaded", () => {
  initAccordion();
});

// cart redraw / theme editor
document.addEventListener("shopify:section:load", (e) => {
  initAccordion(e.target);
});
//end of cart cupons

function syncCartPageCount() {
  const lineItems = document.querySelector("[data-cart-line-items]");
  if (!lineItems) return;

  const count = lineItems.querySelectorAll("[data-cart-item]").length;
  document.querySelectorAll("[data-cart-page-count]").forEach((el) => {
    el.textContent = String(count);
  });
}

function initCartPageModern() {
  if (!document.body.classList.contains("template-cart")) return;

  syncCartPageCount();

  const lineItems = document.querySelector("[data-cart-line-items]");
  if (lineItems && !lineItems.dataset.countObserved) {
    lineItems.dataset.countObserved = "true";
    new MutationObserver(syncCartPageCount).observe(lineItems, {
      childList: true,
      subtree: true,
    });
  }

  document.body.classList.toggle(
    "cart-page-has-items",
    !!document.querySelector(".cart-page-modern:not(.hide)")
  );
}

window.initCartPageModern = initCartPageModern;

document.addEventListener("DOMContentLoaded", initCartPageModern);
document.addEventListener("shopify:section:load", initCartPageModern);
document.addEventListener("cart:updated", initCartPageModern);

function initShortDescriptionReadMore(scope = document) {
  scope.querySelectorAll("[data-short-description]").forEach((wrapper) => {
    const content = wrapper.querySelector("[data-short-description-content]");
    const toggle = wrapper.querySelector("[data-short-description-toggle]");
    if (!content || !toggle) return;

    const lines = Number(wrapper.getAttribute("data-clamp-lines")) || 3;
    wrapper.style.setProperty("--short-desc-lines", String(lines));

    // Reset state (important for section re-renders)
    wrapper.classList.remove("is-expanded");
    wrapper.classList.add("is-collapsed");
    toggle.setAttribute("aria-expanded", "false");

    // Determine if it overflows when clamped
    // We need a frame so line-clamp applies before measuring.
    requestAnimationFrame(() => {
      const overflows = content.scrollHeight > content.clientHeight + 1;
      toggle.hidden = !overflows;
      toggle.textContent = (window.theme?.strings?.showMore) || "Read More";
    });

    if (toggle.dataset.bound === "true") return;
    toggle.dataset.bound = "true";

    toggle.addEventListener("click", () => {
      const isExpanded = wrapper.classList.toggle("is-expanded");
      wrapper.classList.toggle("is-collapsed", !isExpanded);
      toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
      toggle.textContent = isExpanded
        ? ((window.theme?.strings?.showLess) || "Read Less")
        : ((window.theme?.strings?.showMore) || "Read More");
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initShortDescriptionReadMore();
});

document.addEventListener("shopify:section:load", (e) => {
  initShortDescriptionReadMore(e.target);
});



  document.addEventListener("DOMContentLoaded", function () {

  const productForm = document.querySelector('[data-product-form]');
  if (!productForm) return;

  const variantSelect = productForm.querySelector('select[name="id"]');
  if (!variantSelect) return;

  document.querySelectorAll('.color-swatch').forEach(function (swatch) {
    swatch.addEventListener('change', function () {

      const variantId = this.dataset.variantId;
      if (!variantId) return;

      // 1️⃣ Update main variant select
      variantSelect.value = variantId;

      // 2️⃣ Fire Shopify change event
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

      // 3️⃣ Update image manually (your theme needs this)
      const targetImage = document.querySelector(
        '.product-single__photo[data-image-id]'
      );

      const productData = JSON.parse(
        document.getElementById('ProductJson-{{ section.id }}').textContent
      );

      const variant = productData.variants.find(v => v.id == variantId);

      if (variant && variant.featured_image) {
        document.querySelectorAll('.product-single__photo-wrapper').forEach(img => {
          img.style.display = 'none';
        });

        const imgToShow = document.querySelector(
          '[data-image-id="' + variant.featured_image.id + '"]'
        );

        if (imgToShow) {
          imgToShow.closest('.product-single__photo-wrapper').style.display = 'block';
        }
      }

    });
  });
});

// Horizontal thumbnail navigation for product images (Amazon style)
// Fix: thumbnail click must change the main image via Slick asNavFor sync
(function() {
  if (typeof jQuery === 'undefined') return;
  
  function initProductImageSync() {
    var $ = jQuery;
    
    // ---------- DEFAULT TEMPLATE (page-product-detail-default) ----------
    // Skip Slick when new card gallery is present (product-gallery-card.liquid).
    if (!$('.page-product-detail-default .product-gallery[data-product-gallery]').length) {
      var $defaultSlider = $('.page-product-detail-default .product-slider');
      if ($defaultSlider.length) {
        var $defaultFor = $defaultSlider.find('.slider-for');
        var $defaultNav = $defaultSlider.find('.slider-nav');
        
        if ($defaultFor.length && $defaultNav.length) {
          if ($defaultNav.hasClass('slick-initialized')) {
            $defaultNav.slick('unslick');
          }
          if ($defaultFor.hasClass('slick-initialized')) {
            $defaultFor.slick('unslick');
          }
          
          $defaultFor.slick({
            rows: 0,
            fade: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            infinite: false
          });
          
          $defaultNav.slick({
            rows: 0,
            infinite: true,
            vertical: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            focusOnSelect: true,
            asNavFor: $defaultFor,
            touchThreshold: 10,
            swipeToSlide: true,
            prevArrow: '<div class="slick-prev slick-arrow"><svg class="icon"><use xlink:href="#icon-chevron-left"></svg></div>',
            nextArrow: '<div class="slick-next slick-arrow"><svg class="icon"><use xlink:href="#icon-chevron-right"></svg></div>',
            responsive: [
              { breakpoint: 992, settings: { slidesToShow: 5, slidesToScroll: 1, infinite: true, swipeToSlide: true } },
              { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 1, infinite: false, swipeToSlide: true } },
              { breakpoint: 550, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: false, swipeToSlide: true } }
            ]
          });
          $defaultNav.find('.product-single__thumbnail').off('click');
        }
      }
    }
    
    // ---------- TEMPLATE-01 (ProductSection-product-template-01) ----------
    // Theme already inits both with asNavFor. Force horizontal and ensure sync.
    var $t01Slider = $('#ProductSection-product-template-01 .product_layout .product_photos .product-slider');
    if ($t01Slider.length) {
      var $t01For = $t01Slider.find('.slider-for');
      var $t01Nav = $t01Slider.find('.slider-nav');
      
      if ($t01For.length && $t01Nav.length) {
        if ($t01Nav.hasClass('slick-initialized')) {
          $t01Nav.slick('unslick');
        }
        if ($t01For.hasClass('slick-initialized')) {
          $t01For.slick('unslick');
        }
        
        $t01For.slick({
          rows: 0,
          fade: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: $t01Nav,
          adaptiveHeight: true
        });
        
        $t01Nav.slick({
          rows: 0,
          infinite: true,
          vertical: false,
          slidesToShow: 6,
          slidesToScroll: 1,
          arrows: true,
          focusOnSelect: true,
          asNavFor: $t01For,
          touchThreshold: 10,
          swipeToSlide: true,
          prevArrow: '<div class="slick-prev slick-arrow"><svg class="icon"><use xlink:href="#icon-chevron-left"></svg></div>',
          nextArrow: '<div class="slick-next slick-arrow"><svg class="icon"><use xlink:href="#icon-chevron-right"></svg></div>',
          responsive: [
            { breakpoint: 992, settings: { slidesToShow: 5, slidesToScroll: 1, infinite: true, swipeToSlide: true } },
            { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 1, infinite: false, swipeToSlide: true } },
            { breakpoint: 550, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: false, swipeToSlide: true } }
          ]
        });
      }
    }
  }
  
  jQuery(document).ready(function($) {
    // Prevent thumbnail link navigation; scroll up to main image only when main image is not in view
    $(document).on('click', '.product-slider .slider-nav .product-single__thumbnail, .product-slider .slider-nav a[href][data-thumbnail-id], .product-slider .slider-nav .item a', function(e) {
      var $nav = $(this).closest('.slider-nav');
      if (!$nav.length || !$nav.hasClass('slick-initialized')) return;
      e.preventDefault();
      var $mainImage = $nav.closest('.product-slider').find('.slider-for').first();
      if (!$mainImage.length) return;
      var mainImageTop = $mainImage.offset().top - 80;
      var scrollTolerance = 60;
      // Only scroll when user has scrolled down past the main image (main image not in view above)
      if ($(window).scrollTop() > mainImageTop + scrollTolerance) {
        setTimeout(function() {
          $('html, body').animate({ scrollTop: Math.max(0, mainImageTop) }, 320);
        }, 50);
      }
    });
    
    // Variant change: sync new card gallery to variant's featured image
    $(document).on('variantChange variantImageChange', function(evt) {
      if (!evt.variant || !evt.variant.featured_media) return;
      var $container = $(evt.target);
      var hasGallery = $container.hasClass('product_quickview') || $container.find('.product-gallery[data-product-gallery]').length;
      if (!hasGallery) return;
      if (window.MiraviProductGallery && window.MiraviProductGallery.goToMediaId) {
        window.MiraviProductGallery.goToMediaId(evt.variant.featured_media.id);
      }
    });

    // Run after theme's Product section has run
    setTimeout(initProductImageSync, 300);
    setTimeout(initProductImageSync, 1200);
    $(document).on('shopify:section:load', function() {
      setTimeout(initProductImageSync, 400);
    });
  });
  
})();
// Viewport Intersection Observer for Reveal animations
(function () {
  function revealVisible(elements) {
    elements.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add("reveal-active");
      }
    });
  }

  function initRevealObserver() {
    var revealElements = document.querySelectorAll(".reveal-on-scroll");
    if (!revealElements.length) return;

    // Immediately reveal anything already in the viewport (handles bfcache and
    // elements that are visible before the observer can fire).
    revealVisible(revealElements);

    if ("IntersectionObserver" in window) {
      var revealObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-active");
            observer.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        threshold: 0.05,
        rootMargin: "0px 0px 0px 0px"
      });

      revealElements.forEach(function (el) {
        if (!el.classList.contains("reveal-active")) {
          revealObserver.observe(el);
        }
      });
    } else {
      // Fallback: reveal everything immediately
      revealElements.forEach(function (el) {
        el.classList.add("reveal-active");
      });
    }
  }

  document.addEventListener("DOMContentLoaded", initRevealObserver);

  // Handle bfcache restores — DOMContentLoaded does NOT fire for these.
  // event.persisted === true means the page was restored from the cache.
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      var revealElements = document.querySelectorAll(".reveal-on-scroll");
      revealElements.forEach(function (el) {
        el.classList.add("reveal-active");
      });
    }
  });
}());

/* Cart sidebar quantity stepper (+ / −) */
document.addEventListener('click', function (e) {
  var minusBtn = e.target.closest('[data-cart-qty-minus]');
  var plusBtn = e.target.closest('[data-cart-qty-plus]');
  if (!minusBtn && !plusBtn) return;

  e.preventDefault();

  var wrap = (minusBtn || plusBtn).closest('.cart-sidebar-qty');
  if (!wrap) return;

  var input = wrap.querySelector('[data-quantity-input]');
  if (!input) return;

  var value = parseInt(input.value, 10) || 0;
  if (minusBtn) {
    value = Math.max(0, value - 1);
  } else {
    value += 1;
  }

  input.value = value;

  if (window.jQuery) {
    window.jQuery(input).trigger('change');
  } else {
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

/* Quick view: run inline scripts after AJAX load (gallery init, etc.) */
(function () {
  if (typeof jQuery === 'undefined') return;

  function runQuickviewScripts() {
    var container = document.querySelector('#product_quickview .product_template');
    if (!container) return;

    container.querySelectorAll('script:not([src])').forEach(function (script) {
      if (script.dataset.qvExecuted === 'true') return;
      script.dataset.qvExecuted = 'true';
      var el = document.createElement('script');
      el.text = script.textContent;
      document.body.appendChild(el);
      document.body.removeChild(el);
    });

    if (window.MiraviOffersCard && window.MiraviOffersCard.init) {
      window.MiraviOffersCard.init(container);
    }

    var gallery = container.querySelector('.product-gallery[data-product-gallery]');
    if (gallery) {
      var counter = gallery.querySelector('[data-gallery-counter]');
      var thumbs = gallery.querySelectorAll('.thumbnail');
      var slides = gallery.querySelectorAll('.slide');
      if (counter) {
        var total = Math.max(thumbs.length, slides.length, 1);
        var active = gallery.querySelector('.thumbnail.active');
        var index = active ? Array.prototype.indexOf.call(thumbs, active) : 0;
        if (index < 0) index = 0;
        counter.textContent = (index + 1) + ' / ' + total;
      }
    }
  }

  window.runMiraviQuickviewScripts = runQuickviewScripts;

  jQuery(document).ajaxSuccess(function (_event, _xhr, settings) {
    if (settings.url && settings.url.indexOf('view=quickview') !== -1) {
      setTimeout(runQuickviewScripts, 100);
    }
  });
})();

/* Shared product skeleton loader (product page + quick view) */
(function () {
  'use strict';

  var LOADING_CLASS = 'is-product-loading';
  var TEMPLATE_ID = 'miravi-product-skeleton-template';
  var MAX_WAIT_MS = 5000;
  var FADE_MS = 200;

  function getSkeletonNode() {
    var tpl = document.getElementById(TEMPLATE_ID);
    if (!tpl || !tpl.content.firstElementChild) return null;
    return tpl.content.firstElementChild.cloneNode(true);
  }

  function show(container) {
    if (!container) return;
    container.classList.add(LOADING_CLASS);
    if (container.querySelector('[data-product-skeleton]')) return;
    var skeleton = getSkeletonNode();
    if (skeleton) {
      container.insertBefore(skeleton, container.firstChild);
    }
  }

  function hide(container) {
    if (!container) return;
    var skeleton = container.querySelector('[data-product-skeleton]');
    var root = container.querySelector('[data-product-loading]') || container;

    function clearLoadingState() {
      container.classList.remove(LOADING_CLASS);
      if (root && root !== container) {
        root.classList.remove(LOADING_CLASS);
      }
    }

    if (skeleton) {
      skeleton.style.transition = 'opacity ' + FADE_MS + 'ms ease';
      skeleton.style.opacity = '0';
      setTimeout(function () {
        skeleton.remove();
        clearLoadingState();
      }, FADE_MS);
    } else {
      clearLoadingState();
    }
  }

  function waitForReady(container) {
    if (!container) return;

    var root = container.querySelector('[data-product-loading]') || container;
    if (!root.classList.contains(LOADING_CLASS)) return;

    var img = root.querySelector('.main-image, .product-gallery .main-image');
    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      hide(root);
    }

    if (!img) {
      finish();
      return;
    }

    if (img.complete && img.naturalWidth > 0) {
      finish();
      return;
    }

    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
    setTimeout(finish, MAX_WAIT_MS);
  }

  function initPage() {
    var root = document.querySelector('.page-product-detail-default [data-product-loading]');
    if (root) waitForReady(root);
  }

  window.MiraviProductSkeleton = {
    show: show,
    hide: hide,
    waitForReady: waitForReady,
    initPage: initPage
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage);
  } else {
    initPage();
  }
})();

/* Stock limit validation for product and cart quantity controls */
(function () {
  'use strict';

  var SELECTORS = {
    plus:
      '[data-qtt].plus, [data-plus-qtt], [data-qtt-edcart].plus, [data-plus-qtt-edcart], [data-cart-qty-plus]',
    minus:
      '[data-qtt].minus, [data-minus-qtt], [data-qtt-edcart].minus, [data-minus-qtt-edcart], [data-cart-qty-minus]',
    qtyInput: '[data-quantity-input]',
    cartItem: '[data-cart-item]',
    productForm: '[data-product-form], form[action*="/cart/add"]',
    cartErrorWrapper: '[data-cart-quantity-error-message-wrapper]',
    cartErrorMessage: '[data-cart-quantity-error-message]',
    stockMessage: '[data-stock-message]'
  };

  var cartMaxCache = {};

  function getMessage(maxQty) {
    if (window.theme && theme.strings && theme.strings.cartErrorMaximum) {
      return theme.strings.cartErrorMaximum.replace('[quantity]', maxQty);
    }
    return 'Maximum quantity: ' + maxQty + '.';
  }

  function getVariantMaxQty(variantId) {
    if (!variantId || !window.variantInventory) return null;

    var inventory = window.variantInventory[String(variantId)];
    if (!inventory || inventory.max == null) return null;

    var max = parseInt(inventory.max, 10);
    return isNaN(max) || max < 0 ? null : max;
  }

  function getInventoryStrings() {
    var s = (window.theme && theme.strings) || {};
    return {
      inStock: s.in_stock || 'In stock',
      outOfStock: s.out_of_stock || 'Out of stock',
      manyInStock: s.many_in_stock || 'Many in stock'
    };
  }

  function getVariantInventoryQty(variantId) {
    if (!variantId) return null;

    if (window.inven_array && window.inven_array[variantId] != null) {
      var fromLegacy = parseInt(window.inven_array[variantId], 10);
      if (!isNaN(fromLegacy)) return fromLegacy;
    }

    if (window.variantInventory && window.variantInventory[String(variantId)]) {
      var qty = parseInt(window.variantInventory[String(variantId)].qty, 10);
      if (!isNaN(qty)) return qty;
    }

    return null;
  }

  function isVariantInventoryTracked(variantId) {
    if (!variantId || !window.variantInventory) return true;
    var inventory = window.variantInventory[String(variantId)];
    if (!inventory || inventory.tracked == null) return true;
    return Boolean(inventory.tracked);
  }

  function updateProductInventoryDisplay(context) {
    if (!context) return;

    var invWrap = context.querySelector('.product_inventory > span');
    if (!invWrap) return;

    var variantId = getSelectedVariantId(context);
    var strings = getInventoryStrings();

    if (!variantId) return;

    if (!isVariantInventoryTracked(variantId)) {
      invWrap.textContent = strings.manyInStock;
      return;
    }

    var qty = getVariantInventoryQty(variantId);
    if (qty == null || qty <= 0) {
      invWrap.textContent = strings.outOfStock;
      return;
    }

    invWrap.innerHTML =
      '<span class="item-number">' + qty + '</span>' + strings.inStock;
  }

  function getCartMaxQty(cartItem) {
    if (!cartItem) return null;
    var max = parseInt(cartItem.getAttribute('data-max-quantity'), 10);
    return isNaN(max) ? null : max;
  }

  function getProductContext(el) {
    return el.closest(SELECTORS.productForm + ', .product_template, #product_quickview');
  }

  function getSelectedVariantId(context) {
    if (!context) return null;

    var idInput = context.querySelector('[name="id"]');
    if (idInput && idInput.value) return idInput.value;

    var activeVariant = context.querySelector('.pr-active[data-value]');
    return activeVariant ? activeVariant.getAttribute('data-value') : null;
  }

  function getQtyInputFromControl(btn) {
    var wrap = btn.closest('.qty-group, .cart-sidebar-qty, .cart__quantity-td, .cart-edit__qty');
    if (wrap) {
      var input = wrap.querySelector(SELECTORS.qtyInput);
      if (input) return input;
    }

    var siblingInput = btn.parentElement && btn.parentElement.querySelector(SELECTORS.qtyInput);
    return siblingInput || null;
  }

  function resolveMaxQty(controlEl) {
    var cartItem = controlEl.closest(SELECTORS.cartItem);
    if (cartItem) {
      return getCartMaxQty(cartItem);
    }

    return getVariantMaxQty(getSelectedVariantId(getProductContext(controlEl)));
  }

  function showInlineMessage(container, message, input) {
    if (!container) return;

    var cartItem =
      container.matches && container.matches(SELECTORS.cartItem)
        ? container
        : container.closest(SELECTORS.cartItem);

    if (cartItem) {
      var wrapper = cartItem.querySelector(SELECTORS.cartErrorWrapper);
      var msgEl = cartItem.querySelector(SELECTORS.cartErrorMessage);
      if (wrapper && msgEl) {
        msgEl.textContent = message;
        wrapper.classList.remove('hide');
      }
      if (input) input.classList.add('input--error');
      return;
    }

    var stockEl = container.querySelector(SELECTORS.stockMessage);
    if (stockEl) {
      stockEl.textContent = message;
      stockEl.classList.remove('hide');
    } else {
      var errorWrapper = container.querySelector('[data-error-message-wrapper]');
      var errorMsg = container.querySelector('[data-error-message]');
      if (errorWrapper && errorMsg) {
        errorMsg.textContent = message;
        errorWrapper.classList.remove('product-form__error-message-wrapper--hidden');
      }
    }

    if (input) input.classList.add('input--error');
  }

  function hideInlineMessage(container, input) {
    if (!container) return;

    var cartItem =
      container.matches && container.matches(SELECTORS.cartItem)
        ? container
        : container.closest(SELECTORS.cartItem);

    if (cartItem) {
      var wrapper = cartItem.querySelector(SELECTORS.cartErrorWrapper);
      var msgEl = cartItem.querySelector(SELECTORS.cartErrorMessage);
      if (wrapper) wrapper.classList.add('hide');
      if (msgEl) msgEl.textContent = '';
    } else {
      var stockEl = container.querySelector(SELECTORS.stockMessage);
      if (stockEl) {
        stockEl.classList.add('hide');
        stockEl.textContent = '';
      }
    }

    if (input) input.classList.remove('input--error');
  }

  function handlePlusClick(e) {
    var plusBtn = e.target.closest(SELECTORS.plus);
    if (!plusBtn) return;

    var input = getQtyInputFromControl(plusBtn);
    if (!input) return;

    var currentVal = parseInt(input.value, 10) || 0;
    var maxQty = resolveMaxQty(plusBtn);
    if (maxQty == null || maxQty <= 0) return;

    if (currentVal >= maxQty) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var container = plusBtn.closest(SELECTORS.cartItem) || getProductContext(plusBtn);
      showInlineMessage(container, getMessage(maxQty), input);
    }
  }

  function handleMinusClick(e) {
    var minusBtn = e.target.closest(SELECTORS.minus);
    if (!minusBtn) return;

    var input = getQtyInputFromControl(minusBtn);
    var container = minusBtn.closest(SELECTORS.cartItem) || getProductContext(minusBtn);
    if (container && input) hideInlineMessage(container, input);
  }

  function handleQtyInputChange(e) {
    var input = e.target;
    if (!input.matches(SELECTORS.qtyInput)) return;

    var cartItem = input.closest(SELECTORS.cartItem);
    var context = cartItem || getProductContext(input);
    var maxQty = cartItem ? getCartMaxQty(cartItem) : getVariantMaxQty(getSelectedVariantId(context));

    if (maxQty == null || maxQty <= 0) return;

    var val = parseInt(input.value, 10);
    if (isNaN(val) || val <= 0) return;

    if (val > maxQty) {
      input.value = String(maxQty);
      showInlineMessage(context, getMessage(maxQty), input);
    } else {
      hideInlineMessage(context, input);
    }
  }

  function syncProductQtyLimits() {
    document.querySelectorAll(SELECTORS.stockMessage).forEach(function (el) {
      el.classList.add('hide');
      el.textContent = '';
    });

    document.querySelectorAll(SELECTORS.qtyInput).forEach(function (input) {
      input.classList.remove('input--error');
      var context = getProductContext(input);
      var maxQty = getVariantMaxQty(getSelectedVariantId(context));
      var val = parseInt(input.value, 10) || 1;

      if (maxQty != null && maxQty > 0 && val > maxQty) {
        input.value = String(maxQty);
        showInlineMessage(context, getMessage(maxQty), input);
      }
    });
  }

  function handleVariantChange(e) {
    if (
      !e.target.matches('[name="id"], .single-option-selector, input[data-index]')
    ) {
      return;
    }

    var context = getProductContext(e.target);
    updateProductInventoryDisplay(context);
    syncProductQtyLimits();
  }

  if (window.jQuery) {
    window.jQuery(document).on('variantChange', function (evt) {
      var target = evt.target;
      var context =
        target && target.nodeType === 1
          ? getProductContext(target) ||
            (target.closest
              ? target.closest('[data-section-type="product"]')
              : null)
          : null;
      updateProductInventoryDisplay(context);
      syncProductQtyLimits();
    });
  }

  document.addEventListener('click', handlePlusClick, true);
  document.addEventListener('click', handleMinusClick, true);
  document.addEventListener('change', handleQtyInputChange, true);
  document.addEventListener('change', handleVariantChange, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.pr-swatch')) {
      var context = getProductContext(e.target);
      setTimeout(function () {
        updateProductInventoryDisplay(context);
        syncProductQtyLimits();
      }, 0);
    }
  });

  window.MiraviStockLimit = {
    getMessage: getMessage,
    getVariantMaxQty: getVariantMaxQty,
    updateProductInventoryDisplay: updateProductInventoryDisplay,
    cacheCartMax: function (variantId, maxQty) {
      if (variantId != null && maxQty != null && !isNaN(maxQty)) {
        cartMaxCache[String(variantId)] = maxQty;
      }
    },
    getCachedCartMax: function (variantId) {
      if (variantId == null) return null;
      var max = cartMaxCache[String(variantId)];
      return max != null ? max : null;
    }
  };
})();
